import React from 'react';

const ServiceDetails = () =>{

  return(
    <>
       <div className="breadcumb-wrapper" style={{ backgroundImage: "url('/assets/img/bg/breadcumb-bg.jpg')" }}>
          <div className="container">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Service Details</h1>
              <ul className="breadcumb-menu">
                <li><a href="/">Home</a></li>
                <li><a href="/services">Services</a></li>
                <li>Service Details</li>
              </ul>
            </div>
          </div>
        </div>
        <section className="space-top space-extra-bottom">
          <div className="container">
            <div className="row">
              <div className="col-xxl-8 col-lg-8">
                <div className="page-single mb-0">
                  <div className="page-img"><img src="/assets/img/service/construct_serv.png" alt="Service Details"/></div>
                  <div className="page-content">
                    <h3 className="sec-title page-title">Health & Safety</h3>
                    <p className="sec-textmb-30">We make your working environment as safe as possible by carefully performing risk assessments and executing preventative measures. Through a range of international standards, we ensure that organizations have effective occupational health and safety systems in place to protect employees, generate customer confidence and enhance your business reputation.</p>
                    <p className="sec-text mb-45">Occupational health and safety is a major consideration for successful businesses – the welfare and safety of your staff must be of paramount importance because, as the adage states, people are your most important asset. Plus, apart from looking after your own personnel directly, a good set of QHSE policies will also have a secondary effect: you may also protect co-workers, family members, employers, customers, suppliers, nearby communities, and other members of the public who are impacted by your workplace environment.</p>
                    <p>You will undoubtedly already have health and safety policies and procedures in place. But can you be sure that you are adhering to best practice? Are you complying with local, national and even international regulations? And if you think you are, can you prove it? At MRN HOLDINGS, we have solutions and answers.</p>
                    <p>We offer SHEQ Management Services to obtain professional and cost saving SHEQ System; Risk assessments, SHE legal compliance, Environmental impact assessments, Safety files, OHSAS 18001 implementation, Gap Analysis Audits and ISO 9001( Quality Management System)</p>
                    <p>We will ensure SHEQ compliance to the highest level and make your business a competitive one, we offer free auditing of your business to ensure that compliance is monitored and evaluated timeously.</p>
                    <p>Together, we can make a world of difference to your working world. Contact us now to find out what we could do for you.</p>
                    <h3 className="mb-20">Other Services</h3>
                    <div className="features-wrapper mb-50">
                      <div>
                        <div>
                          <h5 className="service-process_title">Corporate Gifting</h5>
                          <p>At MRN Enterprise, we believe corporate gifting should be more than a formality—it
                            should be meaningful, memorable, and mission-driven. Our curated selection of gifts are
                            designed to reflect your brand’s values while making a real difference in the world.
                          </p>
                          <p>
                            Whether you’re celebrating milestones, thanking clients, recognizing employees, or launching campaigns, our gifting solutions are thoughtful, elegant, and impactful.
                          </p>
                          <p>
                            We offer customized branding options to make every gift a seamless extension of your band.
                            From eco-friendly packaging to ethically sourced materials, we help you give with purpose.
                          </p>
                        </div>
                        <div >
                          <h5 className="service-process_title">Corporate Wear & Branding</h5>
                          <p> 
                            At MRN Enterprise, we understand that corporate wear is more than just a uniform—<strong>it’s
                            a powerful extension of your brand identity.</strong> It communicates professionalism, unity,
                            and your company’s commitment to excellence.
                          </p>
                          <p>
                            We offer high-quality, custom-branded corporate wear designed to suit a variety
                            of industries and work environments. From formal office attire to durable workwear
                            and Personal Protective Equipment (PPE), our apparel solutions combine comfort,
                            functionality, and style. Every garment is tailored to maintain a neat, professional
                            appearance while reinforcing your brand’s visual identity.                          
                          </p>
                          <p>
                            Whether you’re outfitting office staff, field personnel, or event teams, we make sure your
                            brand stands out for the right reasons.                          
                          </p>
                        </div>
                        <div>
                          <h5 className="service-process_title">PPE – Personal Protective Equipment</h5>
                          <p>Our dedicated team offers expert guidance and a wide selection of high-quality PPE
                            products that meet both basic and advanced safety needs. From entry-level items to
                            specialized gear, our catalogue includes:
                            
                            <ol>
                              <li>Eye, ear, and respiratory protection</li>
                              <li>Helmets, gloves, boots, and coveralls</li>
                              <li>High-visibility clothing and fall arrest systems</li>
                              <li>Custom PPE solutions for unique industry needs</li>
                            </ol>

                            We are committed to helping organizations safeguard their workforce with reliable and compliant protective solutions.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-lg-4">
                <aside className="sidebar-area">
                  <div className="widget widget_categories">
                    <h3 className="widget_title">All Services</h3>
                    <ul>
                      <li>Occupational Health & Safety Management Systems<i className="fa-regular fa-arrow-right"></i></li>
                      <li>SHEQ Training<i className="fa-regular fa-arrow-right"></i></li>
                      <li>Construction Health & Safety Files<i className="fa-regular fa-arrow-right"></i></li>
                      <li>Risk Management Systems<i className="fa-regular fa-arrow-right"></i></li>
                      <li>Environmental Management Systems<i className="fa-regular fa-arrow-right"></i></li>
                      <li>Awareness Programmes<i className="fa-regular fa-arrow-right"></i></li>
                      <li>Quality Management Systems<i className="fa-regular fa-arrow-right"></i></li>
                      <li>Workplace Skills Plans (WSP)<i className="fa-regular fa-arrow-right"></i></li>
                      <li>ISO/TS 16949:2009 (Automotive Quality)<i className="fa-regular fa-arrow-right"></i></li>
                    </ul>
                  </div>
                  <div className="widget widget_categories" style={{margin:"500px"}}></div>
                  <div className="widget widget_categories">
                    <img src="/assets/img/service/t-shirt_branding.png" alt="img1"/>
                    <img src="/assets/img/service/shirt_and_cap_branding.png" alt="img1" style={{margin:"150px"}}/>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </section>
    </>
  );
}

export default ServiceDetails;